<!-- eslint-disable indent -->
<!-- eslint-disable indent -->
<template>
    <div class="stack mb-3">
        <div class="m-auto text-left control-width border shadow add-rounded p-4">
            <h3 class="mb-5 kova-text text-center" v-if="!overview">Work with Africa's top talent on demand</h3>
            <div class="alert alert-success" v-if="message">
                <strong>{{ message }}</strong>
            </div>
            <p class="text-danger text-center font-weight-bolder" v-if="error">{{ error }}</p>

            <div>
                <h5 class="mt-4 mb-3 kova-text">Select your speciality</h5>
                <a-select
                    class="w-100"
                    size="large"
                    placeholder="choose your area of speciality"
                    style="width: 120px"
                    :value="speciality"
                    @change="changeSpeciality($event)"
                >
                    <a-select-option :key="stack" v-for="stack in stacks">{{ stack }}</a-select-option>
                </a-select>
            </div>

            <div class="mt-4" v-if="showForFrontEnd">
                <!-- <p>Front-end</p> -->
                <h5 class="kova-text">What is your top tech-stack expertise for front-end?</h5>
                <a-select
                    class="w-100"
                    size="large"
                    placeholder="Select your frontend skill"
                    v-model="core_techstack"
                    style="width: 120px"
                >
                    <a-select-option v-for="front in frontEndStacks" :key="front">{{ front }}</a-select-option>
                </a-select>

                <h5 class="mt-4 kova-text">Projects you've built with your front-end stack?</h5>
                <span class="font-weight-bold">
                    How many?
                    <a-input
                        class="ml-2 w-25"
                        size="large"
                        :min="0"
                        :max="maxLinks"
                        type="number"
                        placeholder="0"
                        @change="preventAlphabetKeys"
                        v-model.number="numLink"
                    />
                </span>
                <br />
                <div :key="n" v-for="n in numLink">
                    <a-input
                        class="mt-3 w-75"
                        addonBefore="https://"
                        :value="projects_completed_links[n - 1] || ''"
                        @change="handleChange({ [n]: $event.target.value })"
                        placeholder="add project link"
                    />
                    <br />
                </div>
            </div>

            <div class="mt-4" v-if="showForUIUX || showForProductManager">
                <!-- <p>Front-end</p> -->
                <h5 class="kova-text">
                    {{ showForUIUX ? 'What is your best design tool?' : "What's your best PM tool?" }}
                </h5>
                <a-select
                    class="w-100"
                    size="large"
                    :placeholder="showForUIUX ? 'Select your design tool' : 'Your best PM tool here'"
                    id="core_techstack"
                    style="width: 120px"
                    v-model="core_techstack"
                >
                    <a-select-option v-for="ui in showForUIUX ? uiTools : pmTools" :key="ui">{{ ui }}</a-select-option>
                </a-select>

                <h5 class="mt-4 kova-text">
                    Number of products {{ showForUIUX ? 'designed' : 'managed' }} with your best tool
                </h5>
                <span class="font-weight-bold">
                    How many?
                    <a-input
                        class="ml-2 w-25"
                        size="large"
                        :min="0"
                        :max="maxLinks"
                        type="number"
                        placeholder="0"
                        v-model.number="numLink"
                    />
                </span>
                <br />
                <div :key="n" v-for="n in numLink">
                    <a-input
                        class="mt-3 w-75"
                        :value="projects_completed_links[n - 1] || ''"
                        addonBefore="https://"
                        @change="handleChange({ [n]: $event.target.value })"
                        placeholder="add project link"
                    />
                    <br />
                </div>
            </div>

            <div class="mt-4" v-if="showForBackEnd">
                <!-- <p>Back-end</p> -->
                <h5 class="kova-text">What is your top tech-stack expertise for Back-end?</h5>
                <a-select
                    class="w-100"
                    size="large"
                    placeholder="Select your backend stack"
                    v-model="core_techstack"
                    style="width: 120px"
                >
                    <a-select-option v-for="back in backEndStacks" :key="back">{{ back }}</a-select-option>
                </a-select>

                <h5 class="mt-4 kova-text">Projects you've built with your back-end stack?</h5>
                <span class="font-weight-bold">
                    How many?
                    <a-input
                        class="ml-2 w-25"
                        size="large"
                        :min="0"
                        :max="maxLinks"
                        type="number"
                        placeholder="0"
                        v-model.number="numLink"
                    />
                </span>
                <br />
                <div :key="n" v-for="n in numLink">
                    <a-input
                        class="mt-3 w-75"
                        :value="projects_completed_links[n - 1] || ''"
                        addonBefore="https://"
                        @change="handleChange({ [n]: $event.target.value })"
                        placeholder="add project link"
                    />
                    <br />
                </div>
            </div>

            <div class="mt-4" v-if="showForFullstack">
                <!-- <p>Back-end</p> -->
                <h5 class="kova-text">What is your top tech stack expertise for frontend stack?</h5>
                <a-select
                    class="w-100"
                    size="large"
                    placeholder="Select your frontend skill"
                    :value="(core_techstack || [])[0]"
                    @change="selectFullStack(0, $event)"
                    style="width: 120px"
                >
                    <a-select-option v-for="frontend in frontEndStacks.filter(key => key !== 'Others')" :key="frontend">
                        {{ frontend }}
                    </a-select-option>
                </a-select>

                <h5 class="mt-4 kova-text">What is your top tech stack expertise for backend stack?</h5>
                <a-select
                    class="w-100"
                    size="large"
                    :value="(core_techstack || [])[1]"
                    placeholder="Select your backend skill"
                    @change="selectFullStack(1, $event)"
                    style="width: 120px"
                >
                    <a-select-option v-for="backend in backEndStacks.filter(key => key !== 'Others')" :key="backend">
                        {{ backend }}
                    </a-select-option>
                </a-select>

                <h5 class="mt-4 kova-text">Projects you've built with your fullstack skills?</h5>
                <span class="font-weight-bold">
                    How many?
                    <a-input
                        class="ml-2 w-25"
                        size="large"
                        :min="0"
                        :max="maxLinks"
                        type="number"
                        placeholder="0"
                        v-model.number="numLink"
                    />
                </span>
                <br />
                <div :key="n" v-for="n in numLink">
                    <a-input
                        class="mt-3 w-75"
                        :value="projects_completed_links[n - 1] || ''"
                        addonBefore="https://"
                        @change="handleChange({ [n]: $event.target.value })"
                        placeholder="add project link"
                    />
                    <br />
                </div>
            </div>

            <div class="mt-4" v-if="showForOther">
                <h5 class="kova-text">What is your top tech-stack expertise for {{ speciality }}?</h5>
                <a-select
                    class="w-100"
                    size="large"
                    :placeholder="`Select your ${speciality} stack`"
                    v-model="core_techstack"
                    style="width: 120px"
                >
                    <a-select-option v-for="spec in otherStacks[otherSpeciality]" :key="spec">
                        {{ spec }}
                    </a-select-option>
                </a-select>
                <h5 class="mt-4 kova-text">Projects you've built with your {{ speciality }} stack?</h5>
                <span class="font-weight-bold">
                    How many?
                    <a-input
                        class="ml-2 w-25"
                        size="large"
                        :min="0"
                        :max="maxLinks"
                        type="number"
                        placeholder="0"
                        v-model.number="numLink"
                    />
                </span>
                <br />
                <div :key="n" v-for="n in numLink">
                    <a-input
                        class="mt-3 w-75"
                        addonBefore="https://"
                        @change="handleChange({ [n]: $event.target.value })"
                        :value="projects_completed_links[n - 1] || ''"
                        :placeholder="
                            speciality === 'Mobile' ? 'add link to App Store or Google Play' : 'add project link'
                        "
                    />
                    <br />
                </div>
            </div>

            <div class="mt-4" v-if="showForOthers">
                <h5 class="kova-text">What's your core tech stack?</h5>
                <a-input
                    class="w-100 mb-3"
                    size="large"
                    placeholder="Your core tech stack here"
                    v-model="core_techstack"
                />
                <span class="mt-4 font-weight-bold">
                    How many?
                    <a-input
                        class="ml-2 w-25"
                        size="large"
                        :min="0"
                        :max="maxLinks"
                        type="number"
                        placeholder="0"
                        v-model.number="numLink"
                    />
                </span>
                <br />
                <div :key="n" v-for="n in numLink">
                    <a-input
                        class="mt-3 w-75"
                        addonBefore="https://"
                        @change="handleChange({ [n]: $event.target.value })"
                        :value="projects_completed_links[n - 1] || ''"
                        placeholder="add project link"
                    />
                    <br />
                </div>
            </div>

            <!-- <h5 class="mt-4 kova-text">How well do you communicate in English?</h5> -->
            <!-- <input type="text" class="input m-auto" id="opt1" placeholder="Full name"/> -->
            <!-- <a-slider id="test" :min="10" @change="english_proficiency = $event" :max="100" :defaultValue="50" /> -->

            <div class="container-fluid px-0 px-md-4 mb-5 mt-5" v-if="!overview">
                <div class="row">
                    <div class="col text-left">
                        <button class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="goBack">
                            Back
                        </button>
                    </div>
                    <div class="col text-right">
                        <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="next">Next</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { backEndStacks, stacks, frontEndStacks, uiTools, pmTools, otherStacks } from '../../data/resources';

export default {
    props: {
        overview: {
            type: Boolean,
            default: false,
        },
    },
    name: 'Fullname',
    data() {
        return {
            english_proficiency: 50,
            stacks,
            frontEndStacks,
            backEndStacks,
            uiTools,
            pmTools,
            otherStacks,
            speciality: '',
            core_techstack: null,
            projects_completed_links: [],
            numLink: 0,
            message: '',
            error: '',
        };
    },
    computed: {
        showForUIUX() {
            return this.speciality == 'UI/UX Designer';
        },
        showForProductManager() {
            return this.speciality == 'Product Manager';
        },
        showForFrontEnd() {
            return this.speciality == 'Frontend';
        },
        showForBackEnd() {
            return this.speciality == 'Backend';
        },
        showForFullstack() {
            return this.speciality == 'Full Stack';
        },
        showForOther() {
            return (
                this.speciality &&
                this.speciality != 'Full Stack' &&
                this.speciality != 'Backend' &&
                this.speciality != 'Frontend' &&
                this.speciality != 'Product Manager' &&
                this.speciality != 'UI/UX Designer' &&
                this.speciality != 'Others'
            );
        },
        showForOthers() {
            return this.speciality == 'Others';
        },
        otherSpeciality() {
            return this.speciality
                .toLowerCase()
                .split(' ')
                .join('-');
        },
    },
    methods: {
        handleChange(data) {
            let key = Object.keys(data);
            this.projects_completed_links[Number(key) - 1] = data[key];
            console.log({ projects_completed_links: this.projects_completed_links });
            this.$forceUpdate();

            const { projects_completed_links } = this;
            this.$store.commit('talent/updateTalent', {
                projects_completed_links,
            });
        },
        selectFullStack(index, skill) {
            this.core_techstack = [...(this.core_techstack || '')];
            this.core_techstack[index] = skill;
            this.$forceUpdate();
        },
        goBack() {
            this.$router.go(-1);
        },
        next() {
            const { core_techstack, projects_completed_links, numLink, speciality, english_proficiency } = this;
            this.error = !speciality
                ? 'Select your speciality'
                : !core_techstack || !core_techstack.length
                ? 'Enter your core tech stack'
                : projects_completed_links.length !== numLink
                ? 'Enter the links to all the projects you did using your corestack'
                : '';

            if (this.error.length) return this.$emit('error');

            this.$store.commit('talent/addToTalent', {
                core_techstack: core_techstack.toString(),
                projects_completed_links,
                speciality,
                english_proficiency,
            });

            this.$router.push('devsignup/speciality');
        },
        changeSpeciality(value) {
            this.speciality = value;
            this.core_techstack = null;
            this.projects_completed_links = [];
            this.numLink = 0;
            this.$forceUpdate();
        },
    },
    mounted() {
        const {
            core_techstack,
            projects_completed_links,
            speciality,
            english_proficiency,
        } = this.$store.state.talent.talentData;

        this.speciality = speciality;
        this.projects_completed_links = projects_completed_links;
        this.numLink = (projects_completed_links || []).length;
        this.english_proficiency = english_proficiency || 50;
        if (core_techstack && core_techstack.includes(','))
            return (this.core_techstack = (core_techstack || []).split(',').filter(key => key.length));
        this.core_techstack = core_techstack || '';
    },
    watch: {
        // showForFullstack() {
        //   if(this.showForFullstack) this.core_techstack = [];
        // },
        core_techstack() {
            const { core_techstack } = this;
            this.$store.commit('talent/updateTalent', {
                core_techstack,
            });
        },
        projects_completed_links() {
            const { projects_completed_links } = this;
            this.$store.commit('talent/updateTalent', {
                projects_completed_links,
            });
        },
        speciality() {
            const { speciality } = this;
            this.$store.commit('talent/updateTalent', {
                speciality,
            });
        },
        english_proficiency() {
            const { english_proficiency } = this;
            this.$store.commit('talent/updateTalent', {
                english_proficiency,
            });
        },
    },
};
</script>
<style scoped>
.input {
    width: 90%;
    height: 50px;
    outline: 0;
    border: solid 1px #20409a;
    border-radius: 5px;
}
.control-width {
    width: 600px;
}

h3.kova-text {
    font-size: 20px;
}

h5.kova-text {
    font-size: 16px;
}

@media (min-width: 768px) and (max-width: 991px) {
}
@media (max-width: 767px) {
    .control-width {
        width: 500px;
    }
}
@media (max-width: 550px) {
    .control-width {
        width: 98%;
    }
}
</style>
